module.exports = __webpack_public_path__ + "resources/img/img_equipment1.0e4e94487b47394b85e46bd1710cd23a.png";